import update from "immutability-helper";
import * as CreDtos from "../CRE.dtos";

import {
    PUBLICATIONS_REQUEST,
    PUBLICATIONS_REQUEST_SUCCESS,
    PUBLICATIONS_REQUEST_FAILURE,
    PUBLICATIONS_FILTER,
    PUBLICATION_EDIT,
    PUBLICATION_ADD,
    PUBLICATION_CANCEL,
    PUBLICATION_UPSERT_REQUEST,
    PUBLICATION_UPSERT_REQUEST_SUCCESS,
    PUBLICATION_UPSERT_REQUEST_FAILURE
} from "../actions/publications.actions";

const initialState = {
    publications: [],
    focus: [],
    states: [],
    publicationTypes: [],
    filteredPublications: [],
    showResource: 0,
    showResources: [{ id: 0, name: "No" }, { id: 1, name: "Yes" }],
    publication: { id: -1 },
    publicationTypeId: 0,
    isLoading: true,
    search: "",
    showDisabled: false,
    isSaving: false
};

function loading(state, isLoading) {
    let newState = update(state, {
        isLoading: { $set: isLoading }
    });
    return newState;
}

function saving(state, isSaving) {
    let newState = update(state, {
        isSaving: { $set: isSaving }
    });
    return newState;
}

function setPublications(state, publications, focus, states, publicationTypes, people) {
    let newState = update(state, {
        publications: { $set: publications },
        focus: { $set: focus },
        states: { $set: states },
        publicationTypes: { $set: publicationTypes },
        people: { $set: people }
    });
    return newState;
}

function setFilter(state, search, showDisabled, publicationTypeId, showResource) {
    let newState = update(state, {
        search: { $set: search },
        showDisabled: { $set: showDisabled },
        publicationTypeId: { $set: publicationTypeId },
        showResource: { $set: showResource }
    });
    return newState;
}

function setFilteredPublications(state) {
    let publications = [...state.publications];
    if (!state.showDisabled) {
        publications = publications.filter(f => f.enabled);
    }
    if (state.search !== "") {
        publications = publications.filter(f => {
            if (f.title) {
                if (f.title.toLowerCase().indexOf(state.search.toLowerCase()) != -1) {
                    return true;
                }
            }
            return false;
        });
    }
    if (state.publicationTypeId != 0) {
        publications = publications.filter(f => {
            if (f.type == state.publicationTypeId) {
                return true;
            }
            return false;
        });
    }

    publications = state.showResource === 0 ? publications.filter(f => !f.isResource) : publications.filter(f => f.isResource);

    let newState = update(state, {
        filteredPublications: { $set: publications }
    });
    return newState;
}

function setPublication(state, publication) {
    if (publication.id != -1) {
        if (publication.id == 0) {
            publication = new CreDtos.Publication();
            publication.id = 0;
            publication.enabled = true;
        }
    }
    let newState = update(state, {
        publication: { $set: publication }
    });
    return newState;
}

export default function publications(state = initialState, action) {
    switch (action.type) {
        case PUBLICATIONS_REQUEST:
            return loading(state, true);
        case PUBLICATIONS_REQUEST_SUCCESS:
            return setFilteredPublications(setPublications(loading(state, false), action.publications, action.focus, action.states, action.publicationTypes, action.people));
        case PUBLICATIONS_REQUEST_FAILURE:
            return loading(state, false);
        case PUBLICATIONS_FILTER:
            return setFilteredPublications(setFilter(state, action.search, action.showDisabled, action.publicationTypeId, action.showResource));
        case PUBLICATION_EDIT:
            return setPublication(state, action.publication);
        case PUBLICATION_ADD:
            return setPublication(state, { id: 0 });
        case PUBLICATION_CANCEL:
            return setPublication(state, { id: -1 });
        case PUBLICATION_UPSERT_REQUEST:
            return saving(state, true);
        case PUBLICATION_UPSERT_REQUEST_SUCCESS:
            return saving(setPublication(state, { id: -1 }), false);
        case PUBLICATION_UPSERT_REQUEST_FAILURE:
            return saving(state, false);
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/publications.ts